(function(app) {

    app.filter("thousandSuffix", function () {
        return function (input, decimals) {
            var suffixes = ["k", "M", "G", "T", "P", "E"];

            if (window.isNaN(input)) {
                return null;
            }

            if (input < 1000) {
                return input;
            }

            var exp = Math.floor(Math.log(input) / Math.log(1000));

            return (input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
        };
    });

})(window.app); //jshint ignore:line